import { render, staticRenderFns } from "./AyudaParte1Muelle.vue?vue&type=template&id=33b68da9&scoped=true"
import script from "./AyudaParte1Muelle.vue?vue&type=script&lang=js"
export * from "./AyudaParte1Muelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b68da9",
  null
  
)

export default component.exports